function Spinner() {
  return (
    <div>
      <img src={require("../assets/loading_spinner.gif")} alt="" />
    </div>
  );
}

export default Spinner;
